import { DateTime, Duration } from "luxon"
import { IPaymentSuccessResponse } from "../../../../../../payments/transactionTypes"

export enum PaymentStatus {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    COMPLETED = "COMPLETED",
    FAILED = "FAILED",
}

export enum PaymentErrorType {
    QUERY_ERROR = "QUERY_ERROR",
    TIMEOUT = "TIMEOUT",
}

type PaymentPending = Readonly<{
    status: PaymentStatus.PENDING
    final: false
}>

type PaymentInProgress = Readonly<{
    status: PaymentStatus.IN_PROGRESS
    final: false
}>

type PaymentCompleted = Readonly<{
    status: PaymentStatus.COMPLETED
    final: true
    response: IPaymentSuccessResponse
}>

type PaymentFailed = Readonly<{
    status: PaymentStatus.FAILED
    final: true
    errorType: PaymentErrorType
    error: unknown
}>

export type PaymentState = PaymentPending | PaymentInProgress | PaymentCompleted | PaymentFailed

export type ProgressState = Readonly<{
    startTime: DateTime
    endTime: DateTime
    remaining: Duration
    progress: number
}>
